var map = {
	"./icon_addmeeting.png": 4497,
	"./icon_addmeeting_on.png": 2897,
	"./icon_back.png": 7920,
	"./icon_config.png": 9263,
	"./icon_dashboard.png": 1069,
	"./icon_dashboard_on.png": 7533,
	"./icon_deepseek.png": 5635,
	"./icon_deepseek_on.png": 6747,
	"./icon_done.png": 4213,
	"./icon_item.png": 1920,
	"./icon_meetings.png": 4911,
	"./icon_meetings_on.png": 6055,
	"./icon_meetinguser.png": 367,
	"./icon_meetinguser_on.png": 4615,
	"./icon_micro.png": 9577,
	"./icon_pause.png": 1023,
	"./icon_play.png": 3047,
	"./icon_questans.png": 4779,
	"./icon_questans_on.png": 467,
	"./icon_settings.png": 4374,
	"./icon_settings_on.png": 5736,
	"./icon_stop.png": 2677,
	"./icon_upload.png": 1550,
	"./icon_upload_on.png": 6560
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9586;